var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "full-view-header header-actions-wrapper bg-white flex flex-align-center flex-justify-between gap-1vw p-l-2rem p-r-2rem p-t-1rem p-b-1rem",
      attrs: { id: "header-actions" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "desktop flex flex-align-center flex-justify-between gap-1vw w-100"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "header-action-section flex-1 flex flex-align-center flex-justify-between gap-1vw"
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "body-base color-link font-bold hov-underline flex-shrink-0",
                  on: {
                    click: function($event) {
                      return _vm.$emit("back")
                    }
                  }
                },
                [_vm._v("\n        < Back\n      ")]
              ),
              _vm._v(" "),
              _vm.currentStep != 2
                ? _c(
                    "div",
                    {
                      staticClass:
                        "buttons-container w-100 flex flex-align-center gap-1vw"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw",
                          on: {
                            click: function($event) {
                              return _vm.$emit("show-filters")
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "purple h-auto hov-primary-img",
                            attrs: {
                              width: "15px",
                              height: "15px",
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "purple h-auto hov-img",
                            attrs: {
                              width: "15px",
                              height: "15px",
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_white.svg?v=1749590428"
                            }
                          }),
                          _vm._v("\n          Filters \n          "),
                          !_vm.selectedCardsOccasions.includes("View All")
                            ? _c("span", [
                                _vm._v(
                                  "\n            (" +
                                    _vm._s(_vm.selectedCardsOccasions.length) +
                                    ")\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.currentStep == 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw",
                              on: {
                                click: function($event) {
                                  return _vm.$emit("show-sort")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "h-auto hov-primary-img",
                                attrs: {
                                  width: "15px",
                                  height: "10px",
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "h-auto hov-img",
                                attrs: {
                                  width: "15px",
                                  height: "10px",
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/sort_white.svg?v=1749590429"
                                }
                              }),
                              _vm._v("\n          Sort Products\n        ")
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw"
            },
            [
              _c("p", { staticClass: "body-base step-text wp-nowrap" }, [
                _vm._v(_vm._s(_vm.currentCopy))
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0"
                },
                [
                  _c("span", { staticClass: "p-r-05rem flex-shrink-0" }, [
                    _vm._v("STEP " + _vm._s(_vm.currentStep) + " OF 4:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 1 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 2 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 3 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "header-action-section between-sticky flex-1 flex flex-align-center flex-justify-end gap-1vw"
            },
            [
              _c(
                "button",
                {
                  staticClass: "hb-btn primary p-l-unset p-r-unset sticky",
                  attrs: { disabled: !_vm.canNext },
                  on: {
                    click: function($event) {
                      return _vm.$emit("next")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "p-r-1rem p-l-1rem desktop" }, [
                    _vm._v("Next Step >")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-r-1rem p-l-1rem mobile" }, [
                    _vm._v("Next >")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "VDropdown",
                {
                  attrs: { distance: 6 },
                  scopedSlots: _vm._u([
                    {
                      key: "popper",
                      fn: function() {
                        return [_c("p", [_vm._v("Saved!")])]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "Save your selections for 24 hours.<br/> Inventory subject to availability",
                            html: true
                          },
                          expression:
                            "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                        }
                      ],
                      staticClass:
                        "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center",
                      on: {
                        click: function($event) {
                          return _vm.$emit("leave-builder")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "color-link font-bold" }, [
                        _vm._v(_vm._s(_vm.headerText) + " ")
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          width: "20",
                          height: "20",
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                          alt: "save cart"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mobile flex flex-align-center flex-justify-between gap-1vw flex-column w-100"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw w-100"
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "body-base color-link font-bold hov-underline flex-shrink-0 flex-1",
                  on: {
                    click: function($event) {
                      return _vm.$emit("back")
                    }
                  }
                },
                [_vm._v("\n        < Back\n      ")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "body-base step-text wp-nowrap flex-2" }, [
                _vm._v(_vm._s(_vm.currentMobileCopy))
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0"
                },
                [
                  _c("span", { staticClass: "p-r-05rem flex-shrink-0" }, [
                    _vm._v("STEP " + _vm._s(_vm.currentStep) + " OF 4:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 1 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 2 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dot" }, [
                    _c("span", {
                      class: 3 <= _vm.currentStep ? "selected" : ""
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex-1 flex flex-align-center flex-justify-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "hb-btn primary p-l-unset p-r-unset sticky",
                      attrs: { disabled: !_vm.canNext },
                      on: {
                        click: function($event) {
                          return _vm.$emit("next")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "p-r-1rem p-l-1rem mobile" }, [
                        _vm._v("Next >")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "VDropdown",
                    {
                      attrs: { distance: 6 },
                      scopedSlots: _vm._u([
                        {
                          key: "popper",
                          fn: function() {
                            return [_c("p", [_vm._v("Saved!")])]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                content:
                                  "Save your selections for 24 hours.<br/> Inventory subject to availability",
                                html: true
                              },
                              expression:
                                "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                            }
                          ],
                          staticClass:
                            "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center noStick",
                          on: {
                            click: function($event) {
                              return _vm.$emit("leave-builder")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "color-link font-bold" }, [
                            _vm._v("Save ")
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              width: "20",
                              height: "20",
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                              alt: "save cart"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "header-action-section w-100 flex flex-align-center flex-justify-between"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "buttons-container w-100 flex flex-align-center gap-1vw"
                },
                [
                  _vm.currentStep != 2
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw",
                          on: {
                            click: function($event) {
                              return _vm.$emit("show-filters")
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "purple h-auto",
                            attrs: {
                              width: "15px",
                              height: "15px",
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                            }
                          }),
                          _vm._v("\n          Filters \n          "),
                          !_vm.selectedCardsOccasions.includes("View All")
                            ? _c("span", [
                                _vm._v(
                                  "\n            (" +
                                    _vm._s(_vm.selectedCardsOccasions.length) +
                                    ")\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw",
                          on: {
                            click: function($event) {
                              return _vm.$emit("show-sort")
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "h-auto",
                            attrs: {
                              width: "15px",
                              height: "10px",
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
                            }
                          }),
                          _vm._v("\n          Sort Products\n        ")
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "VDropdown",
                {
                  attrs: { distance: 6 },
                  scopedSlots: _vm._u([
                    {
                      key: "popper",
                      fn: function() {
                        return [_c("p", [_vm._v("Saved!")])]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "Save your selections for 24 hours.<br/> Inventory subject to availability",
                            html: true
                          },
                          expression:
                            "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                        }
                      ],
                      staticClass:
                        "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center sticky",
                      on: {
                        click: function($event) {
                          return _vm.$emit("leave-builder")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "color-link font-bold" }, [
                        _vm._v("Save ")
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          width: "20",
                          height: "20",
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                          alt: "save cart"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }